@if (visibleContainer) {
  <div class="border border-success rounded" [class.usage-card-grow]="containerGrow" [ngClass]="marginBottom">
    
    <div class="row">
      <div class="col-12">
        <div
          class="alert border-0 alert-primary d-flex justify-content-between align-items-center"
          [ngClass]="expandContainer ? 'mb-3' : 'mb-0'"
          role="alert"
        >
          <strong>{{chartTitle}}</strong>
          <div class="d-flex align-items-center" style="gap: 6px;">
            @if (userDomains) {
              <span class="badge bg-success-subtle text-success fs-11 d-inline-flex align-items-center gap-1">
                <i class="ri-filter-3-line"></i>
                Filtered to {{ userDomainsText }}
                <button class="btn btn-link btn-sm p-0 ms-1 text-primary lh-1" title="Clear the user domain filter" type="button" (click)="userDomainsClear.emit()"><i class="ri-close-line"></i></button>
              </span>
            }
            <span
              *ngIf="!expandContainer && showTitleHintText"
              class="text-muted"
              style="font-size: 0.85em;"
            >
              Chart
            </span>
            <i class="fs-5"
               [attr.data-bs-toggle]="'tooltip'"
               [attr.data-bs-title]="expandContainer ? 'Collapse' : 'Expand'"
               [ngClass]="expandContainer ? 'bx bx-up-arrow' : 'bx bx-down-arrow'"
               style="cursor: pointer; color: #198754;"
               (click)="toggleContainerExpansion()">
            </i>
            <i *ngIf="allowContainerClose"
               class="fs-3 bx bx-x"
               [attr.data-bs-toggle]="'tooltip'"
               data-bs-title="Close"
               style="cursor: pointer; color: #dc3545;"
               (click)="closeContainer()">
            </i>
          </div>
        </div>
      </div>
    </div>
    
    @if (devicesEndOfLifeChart != undefined) {
      <div class="row" [class.d-none]="!expandContainer">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <apx-chart #chartRef
                [chart]="devicesEndOfLifeChart.chart"
                [colors]="devicesEndOfLifeChart.colors"
                [dataLabels]="devicesEndOfLifeChart.dataLabels"
                dir="ltr"
                [fill]="devicesEndOfLifeChart.fill"
                [labels]="devicesEndOfLifeChart.labels"
                [markers]="devicesEndOfLifeChart.markers"
                [plotOptions]="devicesEndOfLifeChart.plotOptions"
                [series]="devicesEndOfLifeChart.series"
                [stroke]="devicesEndOfLifeChart.stroke"
                [title]="devicesEndOfLifeChart.title"
                [tooltip]="devicesEndOfLifeChart.tooltip"
                [xaxis]="devicesEndOfLifeChart.xaxis"
                [yaxis]="devicesEndOfLifeChart.yaxis"
              >
              </apx-chart>
            </div>
          </div>
        </div>
      </div>
    } @else if (noData) {
      <div class="row">
        <div class="col-12">
          <div class="alert alert-danger mb-0 text-center" role="alert">
            No data available
          </div>
        </div>
      </div>
    }
    
  </div>
}
